import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axiosConfig from 'utils/axiosConfig'
import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import { Box, Grid, Paper, Typography, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody,
  Tabs, Tab } from '@material-ui/core'

import 'containers/Examination/Examination.css'

const StudentSubmissions = (props) => {
  const examid = props.match.params.exam
  const [exam, setExam] = useState({})
  const [submissions, setSubmission] = useState([])
  const [examinee, setExaminee] = useState(0)
  const [studentsSubmitted, setStudentSubmitted] = useState(0)

  const getSubmissions = () => {
    axiosConfig.get(`examinations/${examid}/submissions`)
      .then((response) => {
        const responseData = response.data

        if (!responseData.success) {
          console.log(responseData.message)
          return
        }

        setSubmission(responseData.submissions)
        setExam(responseData.examinations)
        setExaminee(responseData.submissions.length)
        setStudentSubmitted(responseData.studentsSubmitted)
      })
  }

  useEffect(() => {
    getSubmissions()
  }, [])

  return (
    <ResponsiveLayout>
      <Grid lg={8} md={6} style={{margin: '0 auto'}}>
        <Paper style={{marginBottom: '20px'}}>
          <Box padding={3}>
            <Link to={`/examinations`}>
              <i className="fa fa-arrow-left"></i> All Examinations
            </Link>
            <Typography variant="h6">{exam.name}</Typography>
            <Typography variant="subtitle1">{exam.description}</Typography>
            <hr />
            <Box paddingTop={1} display="flex" whiteSpace={2} gridGap={30}>
              <Box>
                <i className="fa fa-star"></i> {exam.totalPoints} points
              </Box>
              <Box>
                <i className="fa fa-users"></i> {studentsSubmitted}/{examinee} students submitted their attempts
              </Box>
            </Box>
          </Box>
        </Paper>

        <Paper>
          <Box padding={3} marginBottom={5}>
            <Box marginBottom={5}>
              <Tabs value={0} className="border-b-1 border-b-black">
                <Tab label="Scores" />
              </Tabs>
            </Box>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Student Name</TableCell>
                    <TableCell>Attempts</TableCell>
                    <TableCell>Final Score</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {submissions?.length > 0 && submissions.map(submission => (
                    <TableRow>
                      <TableCell>
                        {submission.student.user.name}
                      </TableCell>
                      <TableCell>{submission.attempts_count}/{exam.max_attempt}</TableCell>
                      <TableCell>
                        {submission.verified && (
                          <small>{submission.score}</small>
                        )}
                        {!submission.verified && (
                          <small>
                            <i>Pending Verification</i>
                          </small>
                        )}
                      </TableCell>
                      <TableCell align="right">
                        <Link to={`/examinations/${examid}/submissions/${submission.student.id}`}>
                          <Button variant="contained" color="primary" size="small" disableElevation>
                            <i className="fa fa-eye"></i> &nbsp; View Attempts
                          </Button>
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Paper>
      </Grid>
    </ResponsiveLayout>
  )
}

export default StudentSubmissions